import React, { useEffect } from 'react';

// L'application Android se télécharge UNIQUEMENT sur Google Play (décision de Hery, 2026-10-16) : plus aucun APK n'est proposé.
// Cette page est conservée seulement pour que les anciens liens « /download » mènent au Play Store.
const PLAY_URL = 'https://play.google.com/store/apps/details?id=io.tdidigital.teckia';

export default function DownloadPage() {
  useEffect(() => {
    const t = setTimeout(() => window.location.replace(PLAY_URL), 600);
    return () => clearTimeout(t);
  }, []);

  return (
    <div style={{ minHeight: '100vh', background: '#05060f', color: '#f4f6ff', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24, fontFamily: "'DM Sans','Segoe UI',Arial,sans-serif", textAlign: 'center' }}>
      <div>
        <img src="/Teckia-smil.png" alt="TeckiA" style={{ width: 96, height: 96, borderRadius: '50%', objectFit: 'cover', marginBottom: 18 }} />
        <h1 style={{ fontSize: 24, margin: '0 0 8px' }}>TeckiA est sur Google Play</h1>
        <p style={{ color: 'rgba(226,230,255,.65)', margin: '0 0 22px' }}>Redirection vers le Play Store…</p>
        <a href={PLAY_URL} style={{ display: 'inline-block', padding: '13px 26px', borderRadius: 14, background: 'linear-gradient(135deg,#2dd4c8,#7c6fee 55%,#a855f7)', color: '#fff', fontWeight: 800, textDecoration: 'none' }}>
          Ouvrir Google Play
        </a>
      </div>
    </div>
  );
}
